import {useMemo} from 'react';
import {ColumnDef} from '@tanstack/react-table';
import {useIntl} from 'react-intl';
import {PageTitle} from '../../../_metronic/layout/core';
import TableMetronic from '../../common/components/table/TableMetronic';
import ActionIcon from '../../../Components/ActionIcon';
import {useNavigate} from 'react-router-dom';

interface Subscription {
  id: number;
  reference: string;
  name: string;
  status: string;
  productName: string;
  siteName: string;
  startDate: string;
  endDate: string;
}

const Subscriptions = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const subscriptions: Subscription[] = [
    {
      id: 1,
      reference: 'SUB-2024-001',
      name: 'Abonnement Fibre Pro',
      status: 'Actif',
      productName: 'Fibre 1Gb/s',
      siteName: 'Site Paris',
      startDate: '01/01/2024',
      endDate: '31/12/2024',
    },
  ];

  const columns = useMemo<ColumnDef<Subscription>[]>(
    () => [
      {
        header: 'Référence',
        accessorKey: 'reference',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Nom de l\'abonnement',
        accessorKey: 'name',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Statut',
        accessorKey: 'status',
        cell: (info) => {
          const status = info.getValue() as string;
          const color = status === 'Actif' ? '#28a745' : status === 'Inactif' ? '#dc3545' : '#ffc107';
          return (
            <button
              style={{
                backgroundColor: color,
                color: '#fff',
                border: 'none',
                borderRadius: '1em',
                padding: '0.2em 1em',
                fontWeight: 600,
                fontSize: '0.95em',
                cursor: 'default',
              }}
              disabled
            >
              {status}
            </button>
          );
        },
      },
      {
        header: 'Offre',
        accessorKey: 'productName',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Site',
        accessorKey: 'siteName',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Date de début',
        accessorKey: 'startDate',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Date de fin',
        accessorKey: 'endDate',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Actions',
        accessorKey: 'id',
        cell: (info) => {
          const subscriptionId = info.getValue() as number;
          return (
            <ActionIcon
              label="Voir les détails"
              faIcon="fs-1 fa-solid fa-eye"
              onClick={() => {
                navigate(`/my-account/subscriptions/${subscriptionId}`);
              }}
            />
          );
        },
      },
    ],
    [navigate]
  );

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'MENU.MY_SUBSCRIPTIONS'})}
      </PageTitle>
      <TableMetronic<Subscription>
        title="Mes abonnements"
        data={subscriptions}
        columns={columns}
        isLoading={false}
        searchBar={true}
        pagination={true}
      />
    </>
  );
};

export default Subscriptions;
